import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import 'vue-select/dist/vue-select.css';


import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios) //enable axios Globally this.axios.post(...)
//Vue.prototype.axios = axios; 

import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: 'veeFields'
})

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faBackspace } from '@fortawesome/free-solid-svg-icons'
import { faKeyboard } from '@fortawesome/free-solid-svg-icons'
import { faBarcode } from '@fortawesome/free-solid-svg-icons'


import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faTrash)
library.add(faBackspace)
library.add(faBarcode)
library.add(faKeyboard)

import lodash from 'lodash'
import VueLodash from 'vue-lodash'
// name is optional
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

//Validamos si este equipo tiene una caja asignada
router.beforeEach((to, from, next) => {
  if ((!localStorage.getItem('posId') || store.state.UserCardId == "") && to.path != '/setup'){
    next('/setup')
  }
  else{ 
    next()
  }    
  
})


//Vue.prototype.ApiBaseUrl = 'http://10.8.0.1/api/api/'
//Vue.prototype.ApiBaseUrl = 'https://localhost:5001/api/'
//Vue.prototype.ApiBaseUrl = 'http://localhost:8080/API/api/'

//SERVE
//Vue.prototype.ApiBaseUrl = 'http://localhost:5000/api/'


//PUBLISH
//Vue.prototype.ApiBaseUrl = 'http://192.168.1.11/api/api/'
Vue.prototype.ApiBaseUrl = process.env.NODE_ENV === 'production' ? '/api/api/' : 'http://localhost:5000/api/';


//Vue.prototype.PrintDocsFolder =  'http://192.168.1.11/printdocs/'
Vue.prototype.PrintDocsFolder =  '/printdocs/'
Vue.prototype.TicketPrintWSocket = 'ws:///localhost:5003/ws'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
